import { nextfetch } from '@/shared/api/nextfetch'

import { B2BFormOutputModel, TCatalogDiscountApplication } from '../types'

export const fetchDiscountRequest = async (formData: TCatalogDiscountApplication, cookie: string): Promise<void> =>
	await nextfetch<void>(`b24-lead-add`, {
		method: 'POST',
		credentials: `include`,
		headers: {
			Cookie: cookie
		},
		params: {
			...formData
		}
	})

export const fetchB2BDiscountRequest = async (formData: B2BFormOutputModel): Promise<void> =>
	await nextfetch<void>(`b24-lead-add`, {
		method: 'POST',
		params: {
			...formData
		}
	})

export type DiscountMindboxRegisterPayload = {
	NAME: string
	PHONE: string
	EMAIL: string
	TITLE: string
	URL: string
	SEND_TEXT: string
	IS_INDIVIDUAL: 'true' | 'false'
}

export const submitDiscountMindboxRegister = async (payload: DiscountMindboxRegisterPayload): Promise<void> => {
	await nextfetch<void>(`index/discount/mindbox/register`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(payload),
		credentials: 'include'
	})
}

export type MarkdownMindboxRegisterPayload = {
	NAME: string
	PHONE: string
	EMAIL: string
	TITLE: string
	URL: string
	SEND_TEXT: string
	IS_INDIVIDUAL: 'true' | 'false'
}

export const submitMarkdownMindboxRegister = async (payload: MarkdownMindboxRegisterPayload): Promise<void> => {
	await nextfetch<void>(`index/markdown/mindbox/register`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(payload),
		credentials: 'include'
	})
}
